import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '@app/hooks/reduxHooks'
import { readAuthFlag, readUser } from '@app/store/services/local-storage.service'
import { getProfileData } from '@app/store/slices/profile-slice'
import { doLogout } from '@app/store/slices/auth-slice'

import MapBroadcastManager from '@/components/MapBroadcastManager'
import { DevicesProvider } from '@/context/DevicesContext'
import { ThemeProvider } from '@/context/ThemeContext'
import { LoadingState } from '@asad/crane-ui'

import { Sidebar, Topbar } from './components'

const MainLayout = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const profile = useAppSelector((state) => state.profile?.data)
  const isLoading = useAppSelector((state) => state.profile.status === 'loading')

  const userId = readUser()
  const isAuthenticated = readAuthFlag()

  React.useEffect(() => {
    if (!isAuthenticated || !userId?.length) {
      dispatch(doLogout())
      navigate('/auth/login', { replace: true })
    } else if (userId && !profile) dispatch(getProfileData(userId)).unwrap()
  }, [userId, isAuthenticated, dispatch, navigate])

  return (
    /* Provider obejmuje też gałąź ładowania — inaczej motyw nie zostałby nałożony,
       zanim profil dojedzie, i pierwszy ekran mignąłby domyślnym ciemnym. */
    <ThemeProvider>
      {isLoading && !profile ? (
        <div className='flex min-h-screen items-center justify-center bg-crane-background'>
          <LoadingState />
        </div>
      ) : (
        <>
          <MapBroadcastManager />
          {/* `crane-ui-surface` siedzi na Sidebarze, Topbarze i paskach zakładek, celowo NIE tutaj:
              klasa narzuca typografię wszystkim potomkom, więc podniesiona na powłokę przeskalowałaby
              treść każdego zastanego widoku. */}
          <div className='flex min-h-screen bg-crane-background text-crane-foreground'>
            <Sidebar />
            <div className='flex min-w-0 flex-1 flex-col'>
              <Topbar />
              <main className='flex w-full flex-1 flex-col px-3.5 py-4 md:px-5'>
                <DevicesProvider>
                  <Outlet />
                </DevicesProvider>
              </main>
            </div>
          </div>
        </>
      )}
    </ThemeProvider>
  )
}

export default MainLayout
